import { render, staticRenderFns } from "./EditTicket.vue?vue&type=template&id=4036ac14"
import script from "./EditTicket.vue?vue&type=script&lang=js"
export * from "./EditTicket.vue?vue&type=script&lang=js"
import style0 from "./EditTicket.vue?vue&type=style&index=0&id=4036ac14&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports